import { render, staticRenderFns } from "./ScopesInput.vue?vue&type=template&id=c434e9e6&scoped=true&"
import script from "./ScopesInput.vue?vue&type=script&lang=js&"
export * from "./ScopesInput.vue?vue&type=script&lang=js&"
import style0 from "./ScopesInput.vue?vue&type=style&index=0&id=c434e9e6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c434e9e6",
  null
  
)

export default component.exports